import React from 'react';
import { KatAccordion, KatAccordionItem, KatAlert } from '@amzn/katal-react';
import InterimSteps from './InterimSteps';
import ApiRequest from './ApiRequest';
import ApiResponse from './ApiResponse';

import '../App.scss';
import CodeSnippets from './CodeSnippets';

export class ApiContent extends React.Component<{apiSchema: any, authValues: any}> {

    constructor(props: Readonly<{ apiSchema: any, authValues: any; }>) {
        super(props);
    }

    showAuthErrors() {
        if (Object.entries(this.props.authValues.privateKey).length == 0) {
            return(
                <div>
                    <KatAlert
                        id="noKeysLoaded"
                        description="Please visit the Authentication section first to load your private key."
                        header="No authentication credentials set"
                        variant="danger"
                        persistent
                    />
                    <br/>
                </div>
            );
	} else {
            return null;
        }
    }

    render() {
        return (
            <div>
                {this.showAuthErrors()}
                <KatAccordion>
                    <KatAccordionItem id="InterimAccordionRequest" label="Request Parameters" expanded remains-expanded>
                        <ApiRequest
                            apiRequestSchema = {this.props.apiSchema}
                            authValues = {this.props.authValues}
                        />
                    </KatAccordionItem>

                    <KatAccordionItem id="InterimAccordionIntermediate" label="API Request" remains-expanded>
                        <InterimSteps />
                    </KatAccordionItem>

                    <KatAccordionItem id="InterimAccordionResponse" label="API Response" remains-expanded>
                        <ApiResponse />
                    </KatAccordionItem>

                    <KatAccordionItem id="CodeSnippets" label="Code Snippets" remains-expanded>
                        <CodeSnippets
                            api = {this.props.apiSchema}
                            authValues = {this.props.authValues}
                        />
                    </KatAccordionItem>
                </KatAccordion>
            </div>
        );
    }
}

export default ApiContent;
